module.exports = __webpack_public_path__ + "img/star0-10.21fe544b.svg";